import React from 'react';
import InitialMotion from "../../marketingRendering/InitialMotion";

function FeatureRow({
  id,
  alternate = false,
  sectionAlt = false,
  tone = 'green',
  label,
  labelIcon,
  labelTone = tone,
  title,
  body,
  cta,
  visual,
  visualClassName = '',
  children,
}) {
  const sectionClassName = ['feature-row', alternate ? 'alt' : '', alternate || sectionAlt ? 'section-alt' : '']
    .filter(Boolean)
    .join(' ');
  const visualClasses = ['fr-visual', tone, visualClassName].filter(Boolean).join(' ');

  return (
    <section className={sectionClassName} id={id}>
      <div className="container">
        <div className="fr-inner">
          <InitialMotion as="div" motionKey={`${title}-visual`} className={visualClasses} data-aos="fade-up">
            {visual}
          </InitialMotion>
          <InitialMotion as="div" motionKey={`${title}-copy`} data-aos="fade-up">
            {label && (
              <div className="fr-label">
                <span className={`chip ${labelTone}`}>
                  <span className="material-symbols-outlined">{labelIcon}</span>
                </span>
                {label}
              </div>
            )}
            <h2>{title}</h2>
            <p className="fr-body">{body}</p>
            {children}
            {cta && (
              <a href={cta.href} className="text-link">
                {cta.label}
              </a>
            )}
          </InitialMotion>
        </div>
      </div>
    </section>
  );
}

export default FeatureRow;
